import { FiMail, FiArrowUpRight, FiMessageSquare } from "react-icons/fi";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

const contacts = [
  {
    icon: <FiMail size={18} />,
    label: "Email Me",
    href: "mailto:rakeshkadam26498@gmail.com",
    external: false,
    preferred: true,
  },
  {
    icon: <FiMessageSquare size={18} />,
    label: "Consult on Topmate",
    href: "https://topmate.io/rakeshkadam/",
    external: true,
    preferred: false,
  },
  {
    icon: <FaLinkedin size={18} />,
    label: "Connect on LinkedIn",
    href: "https://linkedin.com/in/rakeshkadam",
    external: true,
    preferred: false,
  },
  {
    icon: <FaGithub size={18} />,
    label: "View on GitHub",
    href: "https://github.com/rakesh-kadam",
    external: true,
    preferred: false,
  },
  {
    icon: <FaXTwitter size={18} />,
    label: "Follow on X",
    href: "https://x.com/notrakeshkadam",
    external: true,
    preferred: false,
  },
];

const ContactPage = () => {
  useDocumentTitle("Contact");
  return (
    <div className="flex flex-col items-center justify-center px-6 py-20 text-light-text dark:text-text-primary md:px-10 md:py-24">
      <div className="w-full max-w-lg text-center">
        <p className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-light-muted dark:text-text-faint">
          Contact
        </p>
        <h1 className="mb-4 text-3xl md:text-4xl font-bold tracking-tight">
          Let&apos;s Build Something{" "}
          <span className="text-accent">Serious</span>
        </h1>
        <p className="mx-auto mb-8 max-w-md text-base md:text-lg text-light-muted dark:text-text-muted leading-relaxed">
          Open to conversations around infrastructure, DevSecOps systems, cloud
          architecture, AI-augmented workflows, and real-world engineering problems.
        </p>

        {/* Contact methods */}
        <div className="flex flex-col gap-3">
          {contacts.map((c) => (
            <a
              key={c.label}
              href={c.href}
              {...(c.external
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
              className="group flex items-center justify-between gap-3 rounded-xl border border-light-border bg-light-surface px-6 py-4 text-sm font-semibold transition-all hover:border-accent/30 hover:shadow-card dark:border-border-subtle dark:bg-surface-1 dark:hover:border-accent/20"
            >
              <div className="flex items-center gap-3">
                <span className="text-light-muted transition-colors group-hover:text-accent dark:text-text-muted dark:group-hover:text-accent">
                  {c.icon}
                </span>
                <span className="text-light-text dark:text-text-primary">
                  {c.label}
                </span>
              </div>
              <div className="flex items-center gap-2">
                {c.preferred && (
                  <span className="rounded bg-accent/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-accent">
                    Preferred
                  </span>
                )}
                <FiArrowUpRight
                  size={14}
                  className="text-light-muted dark:text-text-muted opacity-0 group-hover:opacity-100 transition-all group-hover:text-accent"
                />
              </div>
            </a>
          ))}
        </div>

        {/* Response note */}
        <p className="mt-10 text-sm text-light-muted dark:text-text-muted">
          I typically respond within 24-48 hours. For urgent matters, email
          works best.
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
